import { type UUID } from '~/types/common';

import { type GetFtpPollersPayload } from './types';
import { type FtpPollerFileCountPayload } from './useQueryFtpPollerFileCount';

export const queryKeysFtpPoller = {
  base: () => 'ftpPoller' as const,
  get: (ftpPollerId: UUID) =>
    [queryKeysFtpPoller.base(), 'details', ftpPollerId] as const,
  getAll(searchParams: GetFtpPollersPayload | undefined) {
    return searchParams
      ? ([queryKeysFtpPoller.base(), 'list', searchParams] as const)
      : ([queryKeysFtpPoller.base(), 'list'] as const);
  },
  getFileCount: (ftpPollerFileCountPayload: FtpPollerFileCountPayload) =>
    [
      queryKeysFtpPoller.base(),
      'fileCount',
      ftpPollerFileCountPayload,
    ] as const,
} as const;
